/*
 * 表形式オプション（カラーミー互換のマトリクス表示）のセル選択を
 * variant-selects 内の hidden ラジオへ同期する。
 *
 * variant-selects はオプション変更のたびに product-info.js が
 * DOM ごと差し替えるため、セルへ直接リスナーを付けると 1 回目の
 * 差し替えで失われる。document への委譲で差し替え後も動作させる。
 */
if (!window.variantOptionTableInitialized) {
  window.variantOptionTableInitialized = true;

  (() => {
    const CELL_SELECTOR = '.js-option-table-cell';

    const findOptionInput = (group, value) =>
      group
        ? Array.from(group.querySelectorAll('input[type="radio"]')).find((input) => input.value === value)
        : undefined;

    const applySelection = (variantSelects, table, rowValue, columnValue) => {
      const groups = variantSelects.querySelectorAll('fieldset .radio-group');
      const layout = table.dataset.tableLayout;
      let triggerInput = null;

      if (layout === 'vertical-2' || layout === 'horizontal-2') {
        const option1Value = layout === 'vertical-2' ? rowValue : columnValue;
        const option2Value = layout === 'vertical-2' ? columnValue : rowValue;
        const input1 = findOptionInput(groups[0], option1Value);
        const input2 = findOptionInput(groups[1], option2Value);

        if (input1) input1.checked = true;
        if (input2) {
          input2.checked = true;
          triggerInput = input2;
        } else if (input1) {
          triggerInput = input1;
        }
      } else {
        const option1Value = layout === 'horizontal-1' ? columnValue : rowValue;
        const input = findOptionInput(groups[0], option1Value);
        if (input) {
          input.checked = true;
          triggerInput = input;
        }
      }

      if (triggerInput) triggerInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const selectCell = (cell) => {
      if (!cell || cell.classList.contains('none') || cell.getAttribute('aria-disabled') === 'true') return;
      // 同じセルが click と change の両方で届くことがあるため、
      // 選択済みのセルは何もしない（バリエーション取得の二重実行を防ぐ）。
      if (cell.classList.contains('is-selected')) return;

      const table = cell.closest('.js-option-table');
      const variantSelects = cell.closest('variant-selects');
      if (!table || !variantSelects) return;

      table.querySelectorAll(`${CELL_SELECTOR}.is-selected`).forEach((selectedCell) => {
        selectedCell.classList.remove('is-selected');
      });
      cell.classList.add('is-selected');

      const tableRadio = cell.querySelector('input[type="radio"]');
      if (tableRadio) tableRadio.checked = true;

      applySelection(variantSelects, table, cell.dataset.rowValue, cell.dataset.columnValue);
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      selectCell(event.target.closest(CELL_SELECTOR));
    });

    // キャプチャ段階で受けて variant-selects へは伝播させない。
    // バブル段階だと variant-selects のリスナーが先に走り、hidden ラジオが
    // 未同期のままバリエーション取得が 1 回余分に発生するため。
    // 同期後の hidden ラジオの change は通常どおり variant-selects へ届く。
    document.addEventListener(
      'change',
      (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;

        const cell = target.closest(CELL_SELECTOR);
        if (!cell) return;

        event.stopPropagation();
        if (target.checked) selectCell(cell);
      },
      true
    );
  })();
}
